module.exports = __webpack_public_path__ + "static/yondalla-symbol-DND3_FnP-539a47fd5fc25fae6cdfe1fe1e4c7322.webp";